module.exports = function getResource(label) {
    let resources = { sorrySomethingWrong: 'We’re sorry, something went wrong. Please try again.' };
    return resources[label];
};
